export default "__VITE_ASSET__DxpGM06H__"